import { Button, Col, Form, Input, Modal, Row, Typography } from 'antd';
import styled from 'styled-components';
import { checkPersonalPhoneNumber } from '../../util/utils';

const StyledDiv = styled.div``;

interface BidInvitationInputModalProps {
  visible: boolean;
  isEmail: boolean;
  onFinish: (data: any) => void;
}

function BidInvitationInputModal({
  visible,
  isEmail,
  onFinish,
}: BidInvitationInputModalProps) {
  const [form] = Form.useForm();
  const { Text } = Typography;

  return (
    <StyledDiv>
      <Modal
        open={visible}
        title="본인 확인 필요"
        okText="확인"
        centered
        closable={false}
        footer={null}
      >
        <Row justify="center">
          <Col span={21}>
            <Text>
              본 메시지를 수신한 {isEmail ? '이메일을' : '휴대폰 번호를'}{' '}
              입력하세요.
            </Text>
          </Col>
        </Row>
        <Row justify="center" style={{ marginTop: '10px' }}>
          <Col span={21}>
            <Form
              form={form}
              layout="vertical"
              name="control-hooks"
              onFinish={onFinish}
              initialValues={{}}
            >
              {isEmail === false && (
                <Form.Item
                  name="input"
                  style={{ width: '100%' }}
                  rules={[
                    { required: true, message: '휴대폰 번호를 입력하세요.' },
                    {
                      validator: (_, value) => checkPersonalPhoneNumber(value),
                    },
                  ]}
                >
                  <Input placeholder="예) 01012345678" />
                </Form.Item>
              )}

              {isEmail === true && (
                <Form.Item
                  name="input"
                  label="이메일"
                  rules={[
                    {
                      required: true,
                      message: '이메일을 입력 하세요.',
                    },
                    {
                      type: 'email',
                      message: '이메일 입력이 잘못 되었습니다.',
                    },
                  ]}
                >
                  <Input type="email" placeholder="이메일" />
                </Form.Item>
              )}
            </Form>
          </Col>
        </Row>
        <Row justify="center" style={{ marginTop: '20px' }}>
          <Col span={8}>
            <Button
              key="submit"
              type="primary"
              style={{ width: '100%' }}
              onClick={() => {
                form
                  .validateFields()
                  .then((values) => {
                    onFinish(values);
                  })
                  .catch((info) => {
                    console.error('Validate Failed:', info);
                  });
              }}
            >
              확인
            </Button>
          </Col>
        </Row>
      </Modal>
    </StyledDiv>
  );
}

export default BidInvitationInputModal;
